<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first">
          <agent-order-single v-if="activeName == 'first'" :tabCurrent="activeNum"></agent-order-single>
        </el-tab-pane>
        <el-tab-pane label="待发货" name="second">
          <agent-order-single v-if="activeName == 'second'" :tabCurrent="activeNum"></agent-order-single>
        </el-tab-pane>
        <el-tab-pane label="待收货" name="third">
          <agent-order-single v-if="activeName == 'third'" :tabCurrent="activeNum"></agent-order-single>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="fourth">
          <agent-order-single v-if="activeName == 'fourth'" :tabCurrent="activeNum"></agent-order-single>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { queryOrderPageCount } from '@/api/order'
import AgentOrderSingle from './components/AgentOrderSingle.vue'
export default {
  name: 'AgentOrder',
  components: {
    AgentOrderSingle
  },
  data () {
    return {
      imgServer: this.$imgServer,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:99
    }
  },
  mounted () {

  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
      if(tab.name === 'first'){
        this.activeNum = 99
      }else if(tab.name === 'second'){
        this.activeNum = 0
      }else if(tab.name === 'third'){
        this.activeNum = 1
      }else if(tab.name === 'fourth'){
        this.activeNum = 2
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/distributor/Order.vue